import { useParams } from "react-router-dom";
import ClientViewAuditTimeline from "../../components/clientPortal/ClientViewAuditTimeline";
import { MIDPOINT_MEDIA_ADMIN_PORTAL_BASE } from "../../constants/clientAdminPortalRoutes";
import { useClientPortalBase } from "../../hooks/useClientPortalBase";

export default function ClientSettingsAuditPage() {
  const { clientViewId } = useParams();
  const portalBase = useClientPortalBase();
  const isMidpointMedia = portalBase === MIDPOINT_MEDIA_ADMIN_PORTAL_BASE;

  return (
    <>
      <section className="panel-card cp-settings-section-header">
        <h3>Audit log</h3>
        <p className="muted">
          {isMidpointMedia
            ? "Invites, role changes, password resets, and other administrative actions for Midpoint Media."
            : "Invites, role changes, organization assignments, and other administrative actions for this view."}
        </p>
      </section>
      <ClientViewAuditTimeline clientViewId={clientViewId} />
    </>
  );
}
